module.exports = __webpack_public_path__ + "img/happynewyear.3bd093b9.svg";